export default __webpack_public_path__ + "static/media/announcement_2@3x.d2a5e8c8.png";